<template>
    <div>
        <div class="refresh">
            <Icon type="md-refresh" @click="getDate" size="20" />
        </div>
        <Vue2OrgTree
        name="test"
        :data="datas"
        :horizontal="horizontal"
        :label-class-name="labelClassName"
        :render-content="renderContent"
        collapsable
        @on-expand="onExpand"
        @on-node-click="onNodeClick"
        >
        </Vue2OrgTree>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data () {
      return {
        horizontal: false,
        collapsable: true,
        expandAll: false,
        labelClassName: "bg-none",
        datas:{},
        manUrl:require('@/assets/icon00055.png'),
        womanUrl:require('@/assets/icon00055.png'),
        shemaleUrl:require('@/assets/icon00055.png'),
      }
    },
    created(){
        this.getDate()
    },
    mounted(){
        window.goPage = this.goPage
    },
    methods:{
        getDate(){
            axios.post("/OrgPositionImg/selectOrgPositionData", {}).then((res) => {
                if(res){
                    this.datas=res
                    this.toggleExpand(this.datas,true)
                } 
            }).catch(err => {
                this.$Message.info(err);
            })
        },
        onExpand(e, data) {
            if ("expand" in data) {
                data.expand = !data.expand;
                if (!data.expand && data.children) {
                    this.collapse(data.children);
                }
            } else {
                this.$set(data, "expand", true);
            }
        },
        toggleExpand(data, val) {
            var _this = this;
            if (Array.isArray(data)) {
                data.forEach(function(item) {
                _this.$set(item, "expand", val);
                if (item.children) {
                    _this.toggleExpand(item.children, val);
                }
                });
            } else {
                this.$set(data, "expand", val);
                if (data.children) {
                _this.toggleExpand(data.children, val);
                }
            }
        },
        onNodeClick(e, data) {
            //console.log(data.label);
            if(data.url==null){
            return false
            }else{
            window.open(data.url)
            }
        },
        collapse(list) {
            var _this = this;
            list.forEach(function(child) {
            if (child.expand) {
                child.expand = false;
            }
            child.children && _this.collapse(child.children);
            });
        },
        expandChange() {
            this.toggleExpand(this.data, this.expandAll);
        },
        toggleExpand(data, val) {
            var _this = this;
            if (Array.isArray(data)) {
                data.forEach(function(item) {
                    _this.$set(item, "expand", val);
                    if (item.children) {
                    _this.toggleExpand(item.children, val);
                    }
                });
            } else {
                this.$set(data, "expand", val);
                if (data.children) {
                    _this.toggleExpand(data.children, val);
                }
            }
        },
        initOrg(){
            this.$set(this.datas,'expand',true);
            if(this.datas.children){
                this.datas.children.forEach((item,index)=>{
                    this.$set(item,'expand',true);
                })
            }
        },
        goPage(data){
            console.log(data)
        },
        renderContent(h, data) {
          if(data.flag==1){
            return (
                <span style="width:100%;height:100%;display:block;padding:6px 10px;border-radius:3px;" >
                    <dd class="headerPic" style="height:6vh;border-radius:50%;padding:0;margin-bottom:1vh;cursor: pointer;" onClick={(e) => {this.goPage(data)}}>
                    <badge >
                        <img style="width:6vh;height:6vh;border-radius:50%;border: 2px solid #f3d367" src={data.img?data.img:(data.sex === 1?this.manUrl:(data.sex === 2?this.womanUrl:this.shemaleUrl))}/>
                        <icon type="ios-star" slot="count" color="#ed4014" size="16" />
                    </badge>
                    
                    </dd>
                    <dd style="font-size:1.6vh;">{data.label}</dd>
                    <dd style="font-size:1vh;">{data.position}</dd>
                </span>
            )
          }else{
              return (
                <span style="width:100%;height:100%;display:block;padding:6px 10px;border-radius:3px;">
                    <dd class="headerPic" style="height:6vh;border-radius:50%;padding:0;margin-bottom:1vh;cursor: pointer;" onClick={(e) => {this.goPage(data)}}><img style="width:6vh;height:6vh;border-radius:50%;border: 2px solid #f3d367" src={data.img?data.img:(data.sex === 1?this.manUrl:(data.sex === 2?this.womanUrl:this.shemaleUrl))}/></dd>
                    <dd style="font-size:1.6vh;">{data.label}</dd>
                    <dd style="font-size:1vh;">{data.position}</dd>
                </span>
            )
          }
        
      },
    }
}
</script>

<style lang="less" scoped >
/deep/.ivu-badge-count {
    top: 0 !important;
    left: -10px !important;
    
}
.org-tree-container {
    display: flex !important;
    justify-content: center !important;
}
.refresh {
    display: flex !important;
    justify-content: flex-end !important;
}
.org-tree-node-children>.org-tree-node>.org-tree-node-children>.org-tree-node>.org-tree-node-label>.org-tree-node-label-inner{
		// background-color:#c8c8a9;
}
.org-tree-node-children>.org-tree-node>.org-tree-node-children>.org-tree-node:nth-child(3):after{
    border-top: none !important;
}
.org-tree-node-children>.org-tree-node>.org-tree-node-children{
    max-width: 410px !important;
    display: flex !important;
    flex-wrap: wrap !important;
}
.headerPic {
    img {
        border: 2px solid #f3d367 !important;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/site/OrgPosition.vue